/*
 * ===============================================================================================================
 *                                Copyright 2021, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { Box, Button } from '@mui/material';
import { useSelector } from 'react-redux';

import { useStyles } from './styles';
import { LABELS } from './constants';
import SnackbarAlert from '../../shared/SnackbarAlert';
import { selectSnackBarSuccess } from '../../store/snackBar/snackBarSelector';
import RoleAssignmentList from '../../shared/BulkRoleAssignments/RoleAssignmentList';

interface IUserGroupRolesTab {
  edit: boolean;
  groupName: string;
  identifier: string;
  onSave: () => void;
};

const UserGroupRolesTab = ({ edit, identifier, groupName, onSave }: IUserGroupRolesTab) => {
  console.log("UserGroupRolesTab", edit);
  const { classes } = useStyles();
  const selectSucccessMessage = useSelector(selectSnackBarSuccess);

  return (
    <Box className={classes.root}>
      <RoleAssignmentList identifier={identifier} groupName={groupName} />
      <Box>
        <Button
          color="primary"
          onClick={onSave}
          variant="contained"
          className={classes.saveBtnInRolesTab}
        >
          {LABELS.DONE}
        </Button>
      </Box>
      {selectSucccessMessage && selectSucccessMessage.showSnackbar && (
        <SnackbarAlert />
      )}
    </Box>
  );
};

export default UserGroupRolesTab;